import { useMenu } from 'context/MenuContext';
import { useEffect, useState } from 'react';
import groupCompanies from 'handlers/Company/CompanyHandler';
import CompanyGroup from 'models/Profile/CompanyGroups';
import groupedCompanies from './grouped-companies';
import listCompanies from './list-companies';
import styles from './styles.module.scss';
import Interface from './Interface';
import { getCurrentProduct } from 'utils/productCookies';
import SearchInput from './filters/search-input';
import { t } from 'i18next';

type Companies = {
  toogleSettings() : void
}

function Companies(props : Companies) : JSX.Element {
  const { companies } = useMenu();

  const[list, setList] = useState<Interface>();
  const [filterConditions, setFilterConditions] = useState<string>();

  useEffect(() => {
    setList(getCompaniesList());
  }, [filterConditions]);

  const hasGroup = (companiesGroup : Array<CompanyGroup>) : boolean => {
    return companiesGroup.length > 0;
  };

  const getCompaniesList = () : Interface => {
    const companiesGroup = groupCompanies(companies, getCurrentProduct());

    if(hasGroup(companiesGroup))
      return groupedCompanies({ companiesGroup : companiesGroup, filterConditions: filterConditions });

    return listCompanies({ companies : companies, filterConditions: filterConditions });
  };

  if(!list)
    return <></>;

  const Empty = () : JSX.Element => {
    return (
      <div id={styles['biobar-empty-search']}>
        <div>
          <img
            src={require('../../../assets/search.png')}
          />
        </div>
        <p>{t('biobar.profile.companies.empty.title')}</p>
        <p>{t('biobar.profile.companies.empty.body')}</p>
      </div>
    );
  };

  const Companies = () : JSX.Element => {
    if(!list.companies) return <></>;
    if(list.companies.length === 0) return <Empty />;

    return (
      <>
        {list.companies}
      </>
    );
  };

  return (
    <>
      <div className={styles['biobar-product-filter']}>
        <SearchInput setFilterCondition={setFilterConditions} />
      </div>
      <div onClick={props.toogleSettings} id={styles['biobar-companies']}>
        <Companies />
      </div>
    </>
  );
}

export default Companies;